import React from "react";
import {Button, Drawer, Form, Input, Select, Spin} from "antd";

const Option = Select.Option;
const FormItem = Form.Item;
const {TextArea} = Input;

class TaskForm extends React.Component {
  state = {
    visible: false,
    data: [],
    value: [],
    fetching: false
  };
  showDrawer = () => {
    this.setState({
      visible: true
    });
  };
  onClose = () => {
    this.setState({
      visible: false
    });
  };
  handleChange = value => {
    this.setState({
      value,
      fetching: false
    });
  };

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {fetching, data, value} = this.state;
    return (
      <div className="pos-relative">
        <Select mode="default" labelInValue showSearch value={value} placeholder="Select Task"
                notFoundContent={fetching ? <Spin size="small"/> : "No Data Found"} filterOption={false}
                onChange={this.handleChange}
                style={{width: "100%"}}>
            <Option key="1">Lorem Ipsum</Option>
            <Option key="2">Dolar Amet</Option>
            <Option key="3">Amet Ipsum</Option>
        </Select>
        <Button className="plus-btn-pop" htmlType='button' type="primary" onClick={this.showDrawer}>
          <i className="fa fa-plus"/>
        </Button>
        <div>
          <Drawer title="Add Task" placement="right" onClose={this.onClose} visible={this.state.visible}
                  className="floating-form" destroyOnClose={true}>
            <Form>
              <FormItem label="Title">
                {getFieldDecorator('title', {
                  rules: [{required: true, message: 'Please input title'}],
                })(<Input placeholder="Enter title"/>)}
              </FormItem>
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  rules: [{required: true, message: 'Please input description'}],
                })(<TextArea placeholder="Enter job description" rows={4}/>)}
              </FormItem>
              <Button type="primary" htmlType="button">Add</Button>
            </Form>
          </Drawer>
        </div>
      </div>
    );
  }
}

export const Task = Form.create()(TaskForm);


// WEBPACK FOOTER //
// ./src/pages/crm/project_log/log_components/Task.jsx